// src/pages/Orders/OrderLabel.js

import React from 'react';

export const OrderLabel = ({ order }) => {

  const customerCompany =
  order?.customer?.company_name ||
  order?.customer?.companyName ||
  order?.customer?.company ||
  order?.company_name ||
  order?.companyName ||
  '';

  // Step 2: customer full name (fallback)
  const customerFullName = [
    order?.customer?.first_Name || order?.customer?.firstName || order?.first_Name || order?.firstName || '',
    order?.customer?.last_Name  || order?.customer?.lastName  || order?.last_Name  || order?.lastName  || '',
  ]
    .filter(Boolean)
    .join(' ')
    .trim();

  const customerRef =
    order?.customer_Reference ||
    order?.customer_reference ||
    order?.customerRef ||
    'N/A';

  const fullCity =
    order?.city ||
    order?.address?.city ||
    order?.branch ||
    'N/A';

  // ================================================
  // CITY → 3-LETTER CODE MAP
  // ================================================
  const cityCodeMap = {
    // Pakistan
    islamabad: 'ISL',
    lahore: 'LHR',
    karachi: 'KHI',
    rawalpindi: 'RWP',
    faisalabad: 'FSD',
    multan: 'MUX',
    peshawar: 'PSH',
    quetta: 'UET',
    hyderabad: 'HDD',
    sialkot: 'SKT',
    gujranwala: 'GRW',
    bahawalpur: 'BHV',
    sargodha: 'SGD',
    sukabumi: 'SKB',
    abbottabad: 'ABT',
    mirpur: 'MPR',
    gilgit: 'GIL',
    skardu: 'KDU',
    muzaffarabad: 'MZD',
    // UK
    london: 'LON',
    birmingham: 'BHX',
    manchester: 'MAN',
    glasgow: 'GLA',
    liverpool: 'LPL',
    bristol: 'BRS',
    edinburgh: 'EDI',
    leeds: 'LBA',
    sheffield: 'SHF',
    coventry: 'CVT',
    nottingham: 'NTT',
    leicester: 'LEI',
    newcastle: 'NCL',
    belfast: 'BFS',
    cardiff: 'CWL',
  };

  const getBranchCode = (city) => {
    if (!city || city === 'N/A') return 'N/A';
    const key = String(city).trim().toLowerCase();
    if (cityCodeMap[key]) return cityCodeMap[key];
    // Fallback: first 3 letters uppercase
    return String(city).trim().substring(0, 3).toUpperCase();
  };

  const branch = getBranchCode(fullCity);

  return (
    <div
      id="print-label"
      style={{
        width: "60mm",
        height: "20mm",
        backgroundColor: "white",
        padding: "1.5mm 2mm",
        boxSizing: "border-box",
        fontFamily: "Arial, sans-serif",
        display: "flex",
        flexDirection: "column",
        justifyContent: "space-between",
        overflow: "hidden",
        color: "black",
      }}
    >

      {/* TOP: COMPANY + ORDER ID + CUSTOMER REF */}
      <div style={{ flexShrink: 0, margin: 0, padding: 0 }}>

        {/* COMPANY NAME */}
        <div
          style={{
            fontWeight: "900",
            fontSize: "11px",
            fontFamily: "Arial Black, Arial, sans-serif",
            letterSpacing: "0.3px",
            lineHeight: "1.05",
            textAlign: "left",
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis",
          }}
        >
          {customerCompany}
        </div>

        {/* ORDER ID */}
        <div
          style={{
            fontWeight: "900",
            fontSize: "10px",
            fontFamily: "Arial Black, Arial, sans-serif",
            letterSpacing: "0.2px",
            lineHeight: "1.15",
            textAlign: "left",
            marginTop: "1px",
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis",
          }}
        >
          Order ID: {order?.order_Tracking_Id || 'N/A'}
        </div>

        {/* CUSTOMER REF */}
        <div
          style={{
            fontWeight: "900",
            fontSize: "10px",
            fontFamily: "Arial Black, Arial, sans-serif",
            letterSpacing: "0.2px",
            lineHeight: "1.15",
            textAlign: "left",
            marginTop: "1px",
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis",
          }}
        >
          Customer Ref: {customerRef}
        </div>
      </div>

      {/* BOTTOM RIGHT: BRANCH (3-letter code) */}
      <div
        style={{
          flexShrink: 0,
          margin: 0,
          padding: 0,
          textAlign: "right",
        }}
      >
        <span
          style={{
            fontWeight: "900",
            fontSize: "10px",
            fontFamily: "Arial Black, Arial, sans-serif",
            letterSpacing: "0.2px",
            lineHeight: "1",
            whiteSpace: "nowrap",
          }}
        >
          Branch: {branch}
        </span>
      </div>

    </div>
  );
};